<template>
  <guest-layout>
    <template #header>
      Perguruan Tinggi Program Beasiswa Cilegon Juare
    </template>
    <Head title="Perguruan Tinggi Juare" />
    <div class="container flex flex-wrap justify-between p-6 mx-auto my-4 mt-6 max-w-8xl">
      <div class="w-full bg-white shadow">
        <div class="">
          <p class="mt-4 text-sm leading-7 text-gray-500 font-regular" />
          <table class="w-full text-sm divide-y divide-gray-200">
            <thead>
              <tr class="font-bold text-left">
                <th class="px-6 pt-6 pb-4">Nama Perguruan Tinggi</th>
                <th class="hidden px-6 pt-6 pb-4 md:table-cell">Alamat Website</th>
                <th class="hidden px-6 pt-6 pb-4 md:table-cell whitespace-nowrap">Jumlah Prodi</th>
                <th class="px-6 pt-6 pb-4">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="university in universities.data" :key="university.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="p-4 border-t">
                  {{ university.nama }}
                </td>
                <td class="hidden p-4 border-t md:table-cell">
                  <a class="text-indigo-500" target="blank" :href="university.url">
                    {{ university.url }}
                  </a>
                </td>
                <td class="hidden w-6 p-4 text-center border-t md:table-cell whitespace-nowrap">
                  {{ university.jumlah_prodi }} Program Studi
                </td>
                <td class="p-4 border-t">
                  {{ university.status }}
                </td>
              </tr>
              <tr v-if="universities.data.length === 0">
                <td class="px-6 py-4 border-t" :colspan="can('write universitas')? 4 : 3">Tidak ada data universitas.</td>
              </tr>
            </tbody>
          </table>
          <pagination class="m-4" :links="universities.links" />
        </div>
      </div>
    </div>
  </guest-layout>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import GuestLayout from '@/Layouts/GuestLayout.vue'
import Pagination from '@/Shared/Pagination'

export default {
  components:{
    GuestLayout,
    Pagination,
    Head,
  },
  props: {
    universities: Object,
  },
}
</script>

<style>

</style>
